// src/shell/icons.js — иконите на менюто: собствени прости рисунки (SVG).
//
// Защо не знаци от шрифта: ⎙ ◈ ▤ ⇲ ▧ ▥ ▩ ⚇ ≣ ▣ не казваха нищо, а „Заплати"
// носеше ₴ (украинската гривня). Емоджи изглеждат различно на всяко
// устройство, а библиотека с икони е забранена от правилата на фазата.
// Затова: 24×24, линия 1.8 в цвета на текста (currentColor — работи и в
// тъмната тема), без запълване и без твърди цветове. Рисунките са тук, не в
// регистъра: там полето icon е само името от този списък.
// Пази ги test/menu-icons.test.js (всеки раздел има своя, без повторения).

const svg = (body) =>
  '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" ' +
  'stroke-linecap="round" stroke-linejoin="round" focusable="false">' + body + '</svg>';

// Листът на документ (ъгълът горе вдясно е прегънат) — общ за фактура,
// проформа и протокол; различават се по съдържанието.
const SHEET = '<path d="M6 2.5h8.5l4 4V21.5H6z"/><path d="M14.5 2.5v4h4"/>';

export const ICONS = {
  // Качи от телефона: фотоапарат.
  camera: svg('<path d="M3.5 8.5A1.5 1.5 0 0 1 5 7h2.5L9 4.5h6L16.5 7H19a1.5 1.5 0 0 1 1.5 1.5v10A1.5 1.5 0 0 1 19 20H5a1.5 1.5 0 0 1-1.5-1.5z"/><circle cx="12" cy="13.5" r="3.5"/>'),
  // „Още…" в долното меню на телефон: три точки.
  more: svg('<circle cx="5.5" cy="12" r="1.3"/><circle cx="12" cy="12" r="1.3"/><circle cx="18.5" cy="12" r="1.3"/>'),
  // Табло: четири плочки.
  tiles: svg('<rect x="3.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="13.5" width="7" height="7" rx="1.5"/>'),
  // Фактура: документ с редове.
  invoice: svg(SHEET + '<path d="M9 11h6.5M9 14.5h6.5M9 18h3.5"/>'),
  // Проформа: документ с редове и часовник — „още не е фактура".
  proforma: svg('<path d="M12 21.5H6v-19h8.5l4 4V11"/><path d="M14.5 2.5v4h4"/><path d="M9 11h4M9 14.5h2"/><circle cx="17" cy="17" r="4"/><path d="M17 15.3V17l1.2 1"/>'),
  // Контакт: човек.
  person: svg('<circle cx="12" cy="8" r="4"/><path d="M4.5 21c0-4 3.4-6.5 7.5-6.5s7.5 2.5 7.5 6.5"/>'),
  // Артикул: етикет с дупка.
  tag: svg('<path d="M3.5 12.5V4.5a1 1 0 0 1 1-1h8l8 8a1.4 1.4 0 0 1 0 2l-7 7a1.4 1.4 0 0 1-2 0z"/><circle cx="8" cy="8" r="1.5"/>'),
  // Доставка: стрелка към тава — „получено".
  inbox: svg('<path d="M12 3v10M8 9l4 4 4-4"/><path d="M4 13.5v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5"/>'),
  // Склад: три кашона.
  boxes: svg('<rect x="3.5" y="12.5" width="8" height="8" rx="1"/><rect x="12.5" y="12.5" width="8" height="8" rx="1"/><rect x="8" y="3.5" width="8" height="8" rx="1"/>'),
  // Протокол: документ с печат.
  protocol: svg(SHEET + '<path d="M9 9.5h4"/><circle cx="12" cy="15.5" r="3"/>'),
  // Заплати: банкнота.
  banknote: svg('<rect x="2.5" y="6" width="19" height="12" rx="2"/><circle cx="12" cy="12" r="2.8"/><path d="M6 9.5v5M18 9.5v5"/>'),
  // Калкулатор: екран и бутони.
  calculator: svg('<rect x="5" y="2.5" width="14" height="19" rx="2"/><rect x="8" y="5.5" width="8" height="3.5" rx=".5"/><path d="M8.5 13h0M12 13h0M15.5 13h0M8.5 16.5h0M12 16.5h0M15.5 16.5h0"/>'),
  // Задача: квадратче с отметка.
  task: svg('<rect x="3.5" y="3.5" width="17" height="17" rx="3"/><path d="M8 12.2l2.8 2.8L16 9.5"/>'),
  // Чек лист: три реда с отметки.
  checklist: svg('<path d="M3.5 6.5l1.5 1.5L8 5M3.5 12.5l1.5 1.5L8 11M3.5 18.5l1.5 1.5L8 17"/><path d="M11.5 6.5h9M11.5 12.5h9M11.5 18.5h9"/>'),
  // Календар: лист с халки.
  calendar: svg('<rect x="3.5" y="5" width="17" height="16" rx="2"/><path d="M3.5 10h17M8 3v4M16 3v4"/>'),
  // Файлове: два листа един върху друг (оригиналите — ПРОМТ-35).
  files: svg('<path d="M8.5 2.5h7l4 4v11h-11z"/><path d="M15.5 2.5v4h4"/><path d="M5.5 6.5v15h10"/>'),
  // Досие: папка.
  folder: svg('<path d="M3.5 7a1.5 1.5 0 0 1 1.5-1.5h4.5l2 2.5H19a1.5 1.5 0 0 1 1.5 1.5v8.5A1.5 1.5 0 0 1 19 19.5H5A1.5 1.5 0 0 1 3.5 18z"/>'),
  // Автопарк: кола.
  car: svg('<path d="M4 16.5V12l2.2-5h11.6L20 12v4.5z"/><path d="M4 12h16"/><circle cx="7.5" cy="16.5" r="2"/><circle cx="16.5" cy="16.5" r="2"/>'),
  // Мои фирми: сграда с прозорци.
  building: svg('<rect x="5" y="3" width="14" height="18" rx="1"/><path d="M9 7h1.5M13.5 7H15M9 11h1.5M13.5 11H15M10.5 21v-4h3v4"/>'),
  // Изпратени: плик.
  envelope: svg('<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3.5 6.5l8.5 6.5 8.5-6.5"/>'),
  // Потребители: двама души.
  people: svg('<circle cx="9" cy="8" r="3.5"/><path d="M2.5 20c0-3.6 2.9-5.8 6.5-5.8s6.5 2.2 6.5 5.8"/><circle cx="17" cy="9" r="2.5"/><path d="M17.5 14.3c2.3.3 4 1.9 4 4.7"/>'),
  // Одит: лупа.
  magnifier: svg('<circle cx="10.5" cy="10.5" r="6"/><path d="M15 15l5.5 5.5"/>'),
  // Резервни копия: стрелка „назад във времето".
  restore: svg('<path d="M4 12a8 8 0 1 0 2.4-5.7"/><path d="M4 4v4.5h4.5"/><path d="M12 8v4l2.5 2"/>'),
  // Такси: монета с евро.
  euro: svg('<circle cx="12" cy="12" r="9"/><path d="M15.3 8.6a4.3 4.3 0 1 0 0 6.8M7.5 10.8h6M7.5 13.2h6"/>'),
  // Как да…?: пътепоказател.
  signpost: svg('<path d="M12 3v18"/><path d="M5 6h11l3 2.5L16 11H5z"/><path d="M19 13H8l-3 2.5L8 18h11z"/>'),
  // Помощ: въпрос в кръг.
  help: svg('<circle cx="12" cy="12" r="9"/><path d="M9.6 9.4a2.5 2.5 0 1 1 3.6 2.3c-.8.4-1.2 1-1.2 1.8v.5"/><path d="M12 17h0"/>'),
};
